import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from "react-router-dom";
import { Button, IconButton, Grid,Tooltip } from '@material-ui/core';
import { Container} from 'reactstrap';
import coag from './images/coag.jpg';
import './MenuAppBar.css';
import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import { Translate } from "react-localize-redux";
import { Add,  Search } from "@material-ui/icons";
import MenuUser from "../Menus/user/index";
import MenuUserHelp from "../Menus/user/help";
import MenuLanguage from "../Menus/language";
import { purgarStore, goHome, goExpedientesUser, dispatchSetActiveLanguage } from './../../actions/usuarios/index';
import { fetchMuestraModal, fetchCambiaStatoModalBuscador, fetchCambiaStadoModal,fetchocultaModal, fetchCambiaStadoModalFalse  } from './../../actions/interfaz/index';
import { fetchIdAccion } from './../../actions/usuarios/index'

import { CSSTransitionGroup } from 'react-transition-group'
import Modalacciones from '../../components/Home/Modalacciones';


import {isMobile} from "../../api/index";
import {BASE_PATH } from "../../api/config";



class MenuAppBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            auth: true,
            open: false,
        };

    }

    handleHome = () => {
        this.props.goHome();
        this.props.history.push('/');
       
    }

    handleMisexpe = () => {
        this.props.goExpedientesUser();
        this.props.history.push('/');
    }


    handleBuscador() {
        this.props.fetchIdAccion(1); //Nota:el buscador general es como la primera acción. Importante actualizar esto para saber que salimos de Renuncias
        this.props.fetchMuestraModal();
        this.props.fetchCambiaStatoModalBuscador();
        this.props.fetchCambiaStadoModal();
    }

    handleCatalogo() {
        this.props.history.push(`/comunicacion/0/1`)       
    }

    handleNav(uri) {
        this.props.fetchocultaModal();
        this.props.fetchCambiaStadoModalFalse();
        this.props.history.push(uri);
       
    }
    activeButton(){
        let  route =this.props.location.pathname.split('/');
        if(route.length>2){
            if(route[1]=="visualizar-expediente"||route[1]=="tramitacion-en-lote" ){
                return route[2];
            }else return false;

        }else{
           return false
        }
    }

    enPruebas() {
        return BASE_PATH.toLowerCase().includes("serviciosdev");
    }       


    dragOver = (permitido=false) => (event) => {
         
        event.preventDefault();
        if (permitido)
            {event.dataTransfer.dropEffect = "copy"}               
        else
            {event.dataTransfer.dropEffect = "none"}                        
        }

  

        render() {
            let { classes } = this.props;
            let logado=this.props.usuario!=='Login';          
            let enPruebas = this.enPruebas();


            return (    
              
                <Container className="full" >
    
                {logado ?
                    <Grid sx={{ backgroundColor: '#1976d2' }} container spacing={16}  onDragOver={this.dragOver(false)} >
    
                       
                        <Grid item xs={9} sm={9} md={4} lg={3} className={"col-menuappbar"}>
                            <div><a  target="_blank" href="http://portal.coag.es"><img src={coag} alt="logo" height="50" className="logo-coag"/></a></div>                                               
                        </Grid>
                        <Grid item xs={3} sm={3} md={2} lg={2} className={"col-menuappbar"}>
                            <Button color="secondary" className={"button-menuappbar"} onClick={() => { this.handleNav("/") }}>                               
                                <Translate id="languages.header.titleHome" />
                                 {enPruebas? ' en entorno probas':''}     
                            </Button>                         
    
                        </Grid>
                        <Grid item xs={8} sm={9} md={4} lg={5} className={"col-menuappbar"}>
                            <div className="botonesBarra">
                                <Button variant="contained" color="primary" className={"button-menuappbar"}  onClick={() => { this.props.history.push("/nuevo-expediente") }}>
                                    <Translate id="languages.header.btnNewExpedient" />
                                    <Add className={"righticon-menuappbar"} />
    
                                </Button>
                                {/* md por ahora no está disponible
                                <Button disabled={!this.activeButton()} onClick={() => { this.props.history.push("/tramitacion-en-lote/"+this.activeButton()) }} variant="outlined" color="secondary" className={classes.button}>
                                    <Translate id="languages.header.btnTramitacionLote" />
                                    <Settings className={classes.rightIcon} />
                                </Button>
                                */}
                                  <Tooltip title={  !isMobile() ? 'Búsqueda de expedientes':''} >
                                <IconButton color="secondary" className={"button-menuappbar"} 
                                    onClick={() => { this.handleBuscador() }}>
                                    <Search />
                                </IconButton>
                                </Tooltip>
    
                            
                            </div>
    
                        </Grid>
                        <Grid item xs={3} sm={3} md={2} lg={2} className={"col-menuappbar"}>
                      
                            <div className={"menuuser"}>

                           
                            <Tooltip title={ <Translate id="languages.header.catalogoTrabajosToolTip" />} >                                                     
                            { !isMobile() ? 
                        <Button color="secondary"  className={"button-menuappbar"} 
                                onClick={() => { this.handleCatalogo() }}>
                                     {/* esto está asi con &nbsp; para que no rompa hacia abajo y deje de verse el separador si hacemos zoom en la pantalla */}
                                     Catálogo&nbsp;de  <Translate id="languages.generalText.trabajos" />
                                                                   </Button>
                            :                          
                             <Button align="RIGHT" color="secondary" className={"button-menuappbar"} 
                            onClick={() => { this.handleCatalogo() }}>
                                   CATÁLOGO
                            </Button>  
                            }        
                            </Tooltip>         
                                
             
                                {/* <div>
                               <Tooltip id="t1" title={ !isMobile() ?'Manual':''}>
                                                                            <IconButton  
                                                                            color="secondary"
                                                                            buttonRef={node => {
                                                                                this.anchorEl = node;
                                                                            }}
                                                                            aria-owns={this.state.open ? 'menu-list-grow' : undefined}
                                                                            aria-haspopup="true"                                                                        
                                                                            >
                                                                             <Help  style={{marginLeft: 0,marginTop: 1, marginBottom: 2, padding: '0px 0px'}}
                                                                             variant="outlined" onClick={() => {this.openDocInfo();}} />                                                                           
                                                                            </IconButton>  
                                                                        </Tooltip>      
                                </div> */}    
                                <MenuUserHelp align="right" />
                                <MenuLanguage align="right" dispatchSetActiveLanguage={this.props.dispatchSetActiveLanguage}/>
                                <MenuUser align="right" />
                                
                            </div>
                                                 
                           
    
                        </Grid>
                    </Grid>
                    :
    
                        <Grid container spacing={16}  onDragOver={this.dragOver(false)} >
                       
                        <Grid item xs={9}  className={"col-menuappbar"}>
                            <div><a  target="_blank" href="http://portal.coag.es"><img src={coag} alt="logo" height="50" className="logo-coag"/></a></div>
                        </Grid>
                        <Grid item xs={3} className={"col-menuappbar"} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      
                            <div className={"menuuser"}>     
                                    
                                 <Button align={!isMobile()?null:"RIGHT"} color="secondary" className={"button-menuappbar"} 
                                 onClick={() => { this.handleNav("/") }}>
                                     COAG Estudio
                                </Button>                                                               
                                  
                                <MenuLanguage align="right" dispatchSetActiveLanguage={this.props.dispatchSetActiveLanguage}/>                                                                        
                                
                            </div>                                                                   
    
                        </Grid>
    
                    </Grid>
                    }
    
    
                    <div>
                        <CSSTransitionGroup
                            transitionName="acciones"
                            transitionEnterTimeout={2000}
                            transitionLeaveTimeout={100}>
                            {
                                this.props.mostrarModal === true ?                   
                                    <Modalacciones modal={true} key={this.props.idAccion} />
                                    : ''}
                        </CSSTransitionGroup>
                    </div>
                  
                </Container>);
        }
    }
    
MenuAppBar.propTypes = {
    classes: PropTypes.object,
};

const mapStateToProps = state => (
    {
        usuario: state.user.DatosUsuarioValidado.Usuario ? state.user.DatosUsuarioValidado.Usuario : 'Login',
        mostrarModal: state.status.modalAcciones,
        idAccion: state.user.idAccion ? state.user.idAccion : 0
    }
);

const mapDispatchToProps = {
    purgarStore,
    goHome,
    goExpedientesUser,
    fetchMuestraModal,
    fetchIdAccion,
    fetchCambiaStatoModalBuscador,
    fetchCambiaStadoModal,
    dispatchSetActiveLanguage,
    fetchocultaModal, 
    fetchCambiaStadoModalFalse
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withLocalize(MenuAppBar)));
